import { createFileRoute } from "@tanstack/react-router";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";
import { ContactosPanel } from "@/components/admin/ContactosPanel";

const searchSchema = z.object({
  open: z.string().uuid().optional(),
  page: fallback(z.number().int().min(1), 1).default(1),
  pageSize: fallback(z.union([z.literal(50), z.literal(100), z.literal(200)]), 50).default(50),
});

export const Route = createFileRoute("/admin/personas")({
  validateSearch: zodValidator(searchSchema),
  component: ContactosPanel,
});
